import { render } from "./SettlementMonth.vue?vue&type=template&id=87976f66&scoped=true&ts=true"
import script from "./SettlementMonth.vue?vue&type=script&lang=ts"
export * from "./SettlementMonth.vue?vue&type=script&lang=ts"

import "./SettlementMonth.vue?vue&type=style&index=0&id=87976f66&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87976f66"]])

export default __exports__